import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Jiagou from '@/pages/Jiagou'
import Zeren from '@/pages/Zeren'
import Shengming from '@/pages/Shengming'
import Wenhua from '@/pages/Wenhua'
import Contact from '@/pages/ContactUs'
import Yingyong from '@/pages/Yingyong'
import Category from '@/pages/JobCategory'
import Blog from '@/pages/BlogHome'
import BlogDetails from '@/pages/BlogDetails'
import JobSearch from '@/pages/JobSearch'
import JobSingle from '@/pages/JobSingle'
import PricingPlan from '@/pages/PricingPlan'
import Elements from '@/pages/Elements'
import Fuwu from '@/pages/Fuwu'
import Fangan from '@/pages/Fangan'
import Chanpin from '@/pages/Chanpin'
import Jiejueinfo from '@/pages/Jiejueinfo'
import huoban from '@/pages/huoban'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/huoban',
      name: 'huoban',
      component: huoban
    },
    {
      path: '/chanpin',
      name: 'chanpin',
      component: Chanpin
    },
    {
      path: '/jiejueinfo',
      name: 'jiejueinfo',
      component: Jiejueinfo
    },
    {
      path: '/fuwu',
      name: 'fuwu',
      component: Fuwu
    },
    {
      path: '/fangan',
      name: 'fangan',
      component: Fangan
    },
    {
      path: '/jiagou',
      name: 'jiagou',
      component: Jiagou
    },
    {
      path: '/zeren',
      name: 'zeren',
      component: Zeren
    },
    {
      path: '/yingyong',
      name: 'yingyong',
      component: Yingyong
    },
    {
      path: '/shengming',
      name: 'shengming',
      component: Shengming
    },
    {
      path: '/wenhua',
      name: 'wenhua',
      component: Wenhua
    },
    {
      path: '/category',
      name: 'category',
      component: Category
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/blogDetails',
      name: 'blogDetails',
      component: BlogDetails
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/jobSearch',
      name: 'jobSearch',
      component: JobSearch
    },
    {
      path: '/jobSingle',
      name: 'jobSingle',
      component: JobSingle
    },
    {
      path: '/pricingPlan',
      name: 'pricingPlan',
      component: PricingPlan
    },
    {
      path: '/elements',
      name: 'elements',
      component: Elements
    }
  ]
})



//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = 20
// module chunks = 0